export enum QuestionType {
    text = 'text_submission',
    image = 'image_submission'
}
